export const parseCryptoAssetSymbol = (
  symbol: string,
): { chain: string; asset: string } => {
  const [chain, asset] = symbol.split("/");
  return { chain: chain ?? "", asset: asset ?? "" };
};

export const cryptoAssetSymbolToAssetSymbol = (symbol: string): string => {
  return `${getCryptoAssetName(symbol)}USD`;
};

export const getCryptoAssetName = (symbol: string): string => {
  const { chain, asset } = parseCryptoAssetSymbol(symbol);
  if (asset === "NATIVE") {
    return chain;
  }
  return asset;
};
